var CREFERENCE = (function () {
  function init() {
    let references = document.querySelectorAll("[data-reference]");

    references.forEach((reference) => {
      let readMore = reference.querySelector("[data-reference-read-more]");
      let modalData = reference.querySelector(".c-reference-modal");

      readMore.addEventListener("click", function (e) {
        e.preventDefault();
        document.body.appendChild(modalData);
        let closeButton = modalData.querySelector(".c-reference-modal__close");

        closeButton.addEventListener("click", function () {
          modalData.remove();
        });
      });
    });
  }

  return {
    init: init,
  };
})();
